export default __webpack_public_path__ + "static/media/Online-service.8e668253.jpg";